/**
 * Templates pages
 */
( function() {

	const mobileDetect = new MobileDetect(window.navigator.userAgent);
	const continueBtn = document.getElementById('template-form-modal-continue');



	/**
	 * Create the cookie
	 * @param {*} name Cookie name
	 * @param {*} value Cookie value
	 * @param {*} days Days the cookie shall remain active
	 */
	function createCookie(name, value, days) {
		let date = new Date();
		date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
		let expires = "; expires=" + date.toGMTString();
		document.cookie = name + "=" + value + expires + "; path=/; SameSite=None; Secure";
	}

	/**
	 * Get a cookie by name
	 * @param {*} cname Cookie name
	 * @returns Cookie value
	 */
	const getCookie = (name) => {
		const value = `; ${document.cookie}`;
		const parts = value.split(`; ${name}=`);
		if (parts.length === 2) return parts.pop().split(';').shift();
	}

	/**
	 * Show the form alert
	 * @param {*} form The form element
	 * @param {*} message Your message
	 */
	const formError = (form, message) => {
		// Grab the element before the form
		const alert = form.previousElementSibling;

		// Add the message to the alert
		alert.innerHTML = message;

		// Show the alert
		alert.classList.remove('hidden');
	}

	/**
	 * Submit the HS form
	 * @param {*} formData Form data
	 */
	const submitForm = (formData) => {

		// Lets build the URL to submit the form
		const url = `https://api.hsforms.com/submissions/v3/integration/submit/${formData.portalId}/${formData.formId}`;

		// Now lets grab some important information to add to the form
		const pageWrapper = document.querySelector('#primary');
		const wpTitle = pageWrapper.dataset.pageTitle;
		const isMobileRedirect = pageWrapper.dataset.mobileRedirect === '1';
		const mobilePage = pageWrapper.dataset.mobilePage;
		const userConn = pageWrapper.dataset.userConn;

		// Now lets build out the data we need to submit
		const data = {
			fields: [
				{
					objectTypeId: "0-1",
					name: "email",
					value: formData.email
				},
				{
					objectTypeId: "0-1",
					name: "most_recent_template_conversion_url",
					value: formData.redirect
				},
				{
					objectTypeId: "0-1",
					name: "most_recent_template_conversion",
					value: wpTitle ? wpTitle : document.title
				},
			],
			context: {
				pageUri: window.location.href,
				pageName: wpTitle ? wpTitle : document.title
			}
		};

		// Lets quickly add some extra values to our data if we are on mobile
		if (mobilePage && isMobileRedirect) {
			data.fields.push({
				objectTypeId: "0-1",
				name: "template_form_mobile",
				value: mobileDetect.mobile() ? 'Yes' : 'No'
			});
		}

		// If there is a hubspot cookie, then lets add it to the data
		if (document.cookie.includes('hubspotutk')) {
			data.context.hutk = getCookie('hubspotutk');
		}

		// If there is an ip address, then lets add it to the data
		if (userConn) {
			data.context.ipAddress = userConn;
		}

		// Convert the data to JSON
		const json = JSON.stringify(data);

		// Now lets submit the form
		fetch(url, {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: json,
		})
		.then(response => response.json())
		.then(data => {
			console.log('Success:', data);
			// Check the status for an error
			if (data.status === 'error') {
				formError(formData.form, data.errors[0].message);
				return;
			}

			// Lets make sure we fire the GTAG event
			// Facebook
			if (typeof fbq === "function") {
				fbq('track', 'CustomizeProduct');
			}

			// Google
			if (typeof gtag === "function" && window.google_tag_manager) {
				gtag("event", "template_form_complete", {
					"event_callback": function() {
						console.log('GTAG form event fired');
					}
				});
			}

			// Now lets update our utm params if they exist
			if (document.cookie.includes('__coeff-utm2')) {
				const utmParams = getCookie('__coeff-utm2');

				// Decode the utm params
				const decodedUtmParams = JSON.parse(decodeURIComponent(utmParams));

				// If there is a utm_params object, then lets add it to the data
				if (decodedUtmParams.utm_params) {
					decodedUtmParams.utm_params.install_getstarted_url = window.location.href;
				}

				// Update the cookie
				createCookie('__coeff-utm2', encodeURIComponent(JSON.stringify(decodedUtmParams)), 7);
				console.log('UTMs updated');
			}

			// Nice, now lets handle our redirects
			// If the user is on a mobile device, then we need to redirect them to the mobile page
			if (mobilePage && isMobileRedirect && mobileDetect.mobile()) {
				// Add a param to the mobile page url containing the redirect url
				const mobilePageUrl = `${mobilePage}/?paramUrl=${formData.redirect}`
				//window.location.href = mobilePageUrl;
        window.open(mobilePageUrl, '_blank');
				return;
			}

			// If not, lets redirect them to the redirect page on a new tab
      //window.location.href = formData.redirect;
      window.open(formData.redirect, '_blank');

			return;
		})
		.catch((error) => {
			console.error('Error:', error);
			formError(formData.form, 'There was an error submitting the form. Please try again.');
			return;
		});
	}


	const validateForm = (form, formData) => {
		// Get the modal form attribute
		const modalForm = form.dataset.modalForm;
		const button = form.querySelector('input[type="submit"]');

		// We need all of that data to be able to submit the form
		if (!formData.formId || !formData.portalId || !formData.region || !formData.modalId || !formData.email) {
			formError(form, 'Missing form data');
			return;
		}

		// Now lets quickly check if the email is valid
		if (!formData.email.includes('@')) {
			formError(form, 'Invalid email address');
			return;
		}

		// Now check if the email is gmail or yahoo
		if (formData.email.includes('@gmail') || formData.email.includes('@yahoo')) {
			// If the form is not a modal form, then we need to redirect to the modal form
			if (modalForm !== 'true') {
				// Get the modal
				const modal = document.getElementById(formData.modalId);

				// Show the modal
				modal.classList.toggle('show');

				// Get the modal form
				const modalForm = modal.querySelector('.template-hs-form');

				// Add the email to the modal form
				modalForm.dataset.nonBusinessEmail = formData.email;
			} else {
				// Change the form button to a loading state
				button.value = 'Loading...';
				button.disabled = true;

        handleDownloadAction(formData);
			}
		} else {
			// Change the form button to a loading state
			button.value = 'Loading...';
			button.disabled = true;

			//submitForm(formData);
      handleDownloadAction(formData);
		}
	}


  const handleDownloadAction = (formData) => {

    //get the modal Download form
    const validateModal = document.getElementById(formData.modalId);

    const singleDownloadModal = document.getElementById('st-single-download-modal');
    const modalDownloadForm = document.getElementById('st-single-download-modal-form');
    const googleSheetsDownloadBtn = document.getElementById('st-click-google-sheets-download');
    const excelDownloadBtn = document.getElementById('st-click-excel-download');

    //if either excelDownloadBtn or googleSheetsDownloadBtn is false, then that means there is only one download option
    //in that case we do not need to show the modal, we can just submit the form for the user
    //but we have to set the platform and redirect url first before submitting the form
    //otherwise, we show the modal and watch the form
    if (!googleSheetsDownloadBtn || !excelDownloadBtn) {
      //set the redirect for the option that is available
      if (googleSheetsDownloadBtn) {
        formData.redirect = modalDownloadForm.dataset.sheetsUrl;
      }
      if (excelDownloadBtn) {
        formData.redirect = modalDownloadForm.dataset.excelUrl;
      }

      submitForm(formData);

    } else {


      // Hide the validate modal
      validateModal.classList.remove('show');

      singleDownloadModal.classList.add('show');

      const singleDownloadModalClose = document.getElementById('st-single-download-modal-close');
      singleDownloadModalClose.addEventListener('click', (e) => {
        e.preventDefault();
        singleDownloadModal.classList.remove('show');
      });



      googleSheetsDownloadBtn.addEventListener('click', (e) => {
        e.preventDefault();
        formData.redirect = modalDownloadForm.dataset.sheetsUrl;

        excelDownloadBtn.classList.remove('clicked-st-download');
        googleSheetsDownloadBtn.classList.add('clicked-st-download');
      });


      excelDownloadBtn.addEventListener('click', (e) => {
        e.preventDefault();
        formData.redirect = modalDownloadForm.dataset.excelUrl;

        googleSheetsDownloadBtn.classList.remove('clicked-st-download');
        excelDownloadBtn.classList.add('clicked-st-download');
      });


      //watch the form
      modalDownloadForm.addEventListener('submit', (e) => {
        e.preventDefault();
        submitForm(formData);
      });

    }
  }



	// Grab all the forms on the page
	const forms = document.querySelectorAll('.template-hs-form');

	// Add the event listener to each form
	forms.forEach((form) => {
		form.addEventListener('submit', (e) => {
			e.preventDefault();

			// Now lets grab all the data attributes from the form
			const formData = {
				form: form,
				formId: form.dataset.formId,
				portalId: form.dataset.portalId,
				region: form.dataset.region,
				modalId: form.dataset.modalId,
				//redirect: form.dataset.redirect,
				email: form.querySelector('input[name="email"]').value,
			};

			// Run the validate form function
			validateForm(form, formData);
		});
	});

	// Handle the continue button click
	continueBtn.addEventListener('click', (e) => {
		// Prevent default
		e.preventDefault();

		// Get the form
		const formId = continueBtn.dataset.formId;
		const form = document.getElementById(formId);

		// Now lets grab all the data attributes from the form
		const formData = {
			form: form,
			formId: form.dataset.formId,
			portalId: form.dataset.portalId,
			region: form.dataset.region,
			modalId: form.dataset.modalId,
			//redirect: form.dataset.redirect,
			email: form.dataset.nonBusinessEmail,
		};


		// Run the submit form function
		//submitForm(formData);
    handleDownloadAction(formData);
	});


	// Lets quickly look in the URL for the autorun param
	const urlParams = new URLSearchParams(window.location.search);

	// If the autorun param exists, then lets submit the form
	if (urlParams.get('autorun')) {
		// Grab the first form in the header, we will use that to submit
		const form = document.querySelector('.template-hs-form');

		// Now lets set the value of the email to the email provided by the header
		const emailInput = form.querySelector('input[name="email"]');
		const email = urlParams.get('email');

		// If the email exists, then lets set it
		if (email) {
			emailInput.value = email;
		}

		// Now lets gather up our formdata
		const formData = {
			form: form,
			formId: form.dataset.formId,
			portalId: form.dataset.portalId,
			region: form.dataset.region,
			modalId: form.dataset.modalId,
			//redirect: form.dataset.redirect,
			email: email
		};

		// Now lets validate the form
		validateForm(form, formData);
	}


	// Handle the preview images
	const previewImages = document.querySelectorAll('.template-preview-img');

	// If they exist, loop thru and add a click listener
	if (previewImages && previewImages.length) {
		previewImages.forEach((image) => {
			image.addEventListener('click', (e) => {
				// Grab the image src
				const src = e.target.src;

				// Now lets grab the img in the preview modal
				const previewImg = document.getElementById('preview-img-modal-img');

				// Set the src
				previewImg.src = src;

				// Lets also check if there is a data-caption attribute
				if ( e.target.dataset.caption ) {
					// If so, lets grab the caption element
					const caption = document.getElementById('preview-img-modal-caption');

					// Set the caption
					caption.innerHTML = e.target.dataset.caption;

					// If the caption is hidden, then show it
					if (caption.classList.contains('hidden')) {
						caption.classList.remove('hidden');
					}
				} else {
					// Grab the caption element
					const caption = document.getElementById('preview-img-modal-caption');

					// If the caption is not hidden, then hide it
					if (!caption.classList.contains('hidden')) {
						caption.classList.add('hidden');
					}
				}
			});
		});
	}

	// Add the zoom in/out on the content images
	const images = document.querySelectorAll('.templates-content img');

	if (!images || !images.length) return;

	images.forEach((image) => {
		image.addEventListener('click', (e) => {
			// Toggle the zoomed class for the img
			e.target.classList.toggle('zoomed');

			// If the parent is a figure, then toggle the zoomed class for that too
			if (e.target.parentElement.tagName === 'FIGURE') {
				e.target.parentElement.classList.toggle('zoomed');
			}
		})
	})
}() );


// Function to handle the see more
function coeffTemplateSeeMore(button) {
	// Grab the data-target
	const target = button.dataset.target;

	// Select the target
	const targetEl = document.getElementById(target);

	// Lets also grab the see more table of contents if we have it
	const seeMoreToc = document.getElementById('see-more-toc');

	// If the classlist contains hidden, then remove it and change the button text
	if (targetEl.classList.contains('template-see-more-hidden')) {
		targetEl.classList.remove('template-see-more-hidden');
		button.innerHTML = 'See Less';

		// If there is a see more toc, then lets show it
		if (seeMoreToc) {
			seeMoreToc.classList.remove('hidden');
		}
	} else {
		targetEl.classList.add('template-see-more-hidden');
		button.innerHTML = 'See More';

		// If there is a see more toc, then lets hide it
		if (seeMoreToc) {
			seeMoreToc.classList.add('hidden');
		}
	}
}